// extracted by mini-css-extract-plugin
export default {"card":"styles_card__3PzKH","title":"styles_title__J-B6d","subtitle":"styles_subtitle__CLM9o","buttons":"styles_buttons__-an1W"};